import { getTranslate } from '@nx/translations'

import {
  StyledFailedConnectionMessage,
  StyledFireButton,
} from './SubscriptionFailed.styles'
import translate from './SubscriptionFailed.translate.json'

const { text } = getTranslate(translate)

export function SubscriptionFailed({
  refreshCallback,
}: SubscriptionFailedProps) {
  return (
    <>
      <StyledFailedConnectionMessage>
        {text('connectionFailed')}
      </StyledFailedConnectionMessage>
      <div>
        <StyledFireButton variant="ghost" onClick={() => refreshCallback()}>
          {text('refresh')}
        </StyledFireButton>
      </div>
    </>
  )
}

export interface SubscriptionFailedProps {
  refreshCallback: () => void
}
